import "./ReservationPopup.css";

const ReservationPopup = ({ show, closePopup, text }) => {
  return (
    <div className={`reservationPopup ${show && "show"}`}>
      <svg
        onClick={closePopup}
        className="reservationPopup__CloseIcon"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 36.4167C28.619 36.4167 36.4167 28.619 36.4167 19C36.4167 9.38108 28.619 1.58337 19 1.58337C9.38104 1.58337 1.58333 9.38108 1.58333 19C1.58333 28.619 9.38104 36.4167 19 36.4167ZM13.1304 13.1304C13.7487 12.5121 14.7513 12.5121 15.3696 13.1304L19 16.7608L22.6304 13.1304C23.2487 12.5121 24.2513 12.5121 24.8696 13.1304C25.4879 13.7487 25.4879 14.7513 24.8696 15.3696L21.2392 19L24.8696 22.6304C25.4879 23.2487 25.4879 24.2513 24.8696 24.8696C24.2513 25.4879 23.2487 25.4879 22.6304 24.8696L19 21.2392L15.3696 24.8696C14.7513 25.4879 13.7487 25.4879 13.1304 24.8696C12.5121 24.2513 12.5121 23.2487 13.1304 22.6304L16.7608 19L13.1304 15.3696C12.5121 14.7513 12.5121 13.7487 13.1304 13.1304Z"
          fill="#FCFCFC"
        />
      </svg>
      {/* <img alt="" src={"/images/quizz/image1.png"} /> */}
      <h4>{text}</h4>
      {/* <button onClick={closePopup}>
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3" width="20" height="19" rx="3" strokeWidth="2" />
          <path
            d="M7 1V3"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 1V3"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 8H22"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 13H9.5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5 13H16.5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 17H9.5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5 17H16.5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Mes rèservation
      </button> */}
    </div>
  );
};

export default ReservationPopup;
